(() => {
  'use strict';
  const configNode = document.getElementById('OAWishlistConfig');
  const dialog = document.getElementById('OAWishlist');
  if (!configNode || !dialog || window.oaWishlistReady || typeof dialog.showModal !== 'function') return;
  window.oaWishlistReady = true;
  const config = JSON.parse(configNode.textContent);
  const t = config.labels;
  const storageKey = config.preview ? 'oa_saved_gifts_preview_v1' : 'oa_saved_gifts_v1';
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  const list = dialog.querySelector('[data-oa-list]');
  const status = dialog.querySelector('[data-oa-status]');
  const toast = document.querySelector('[data-oa-toast]');
  const products = new Map();
  const refreshed = new Map();
  let memory = [];
  let storageAvailable = true;
  let toastTimer;
  let opener;
  let privacyPromise;
  let refreshVersion = 0;
  let syncQueued = false;
  const key = item => `${item.handle}:${item.variantId || 'choose'}`;
  const validId = value => /^\d+$/.test(String(value || ''));
  const clean = items => Array.isArray(items) ? items.filter(x => x && /^[a-z0-9][a-z0-9-]*$/.test(x.handle) && typeof x.title === 'string' && (x.variantId === null || validId(x.variantId))).slice(0, 100) : [];
  function read() {
    if (!storageAvailable) return memory;
    try {
      const raw = localStorage.getItem(storageKey);
      memory = raw ? clean(JSON.parse(raw)) : [];
    } catch { storageAvailable = false; }
    return memory;
  }
  function write(items) {
    memory = clean(items);
    if (!storageAvailable) return false;
    try { localStorage.setItem(storageKey, JSON.stringify(memory)); return true; }
    catch { storageAvailable = false; return false; }
  }
  function notify(text) {
    status.textContent = text;
    toast.textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  }
  function privacy() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!privacyPromise) privacyPromise = new Promise(resolve => {
      if (!window.Shopify?.loadFeatures) { resolve(null); return; }
      const timeout = setTimeout(() => resolve(null), 2000);
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        clearTimeout(timeout);
        resolve(error ? null : window.Shopify.customerPrivacy);
      });
    });
    return privacyPromise;
  }
  async function track(action, item, source = 'saved_list') {
    if (config.preview) return;
    try {
      const permissions = await privacy();
      if (!permissions?.analyticsProcessingAllowed?.()) return;
      const data = {source, wishlist_count: memory.length, currency: config.currency};
      if (item) {
        data.product_id = String(item.productId);
        data.variant_id = item.variantId ? String(item.variantId) : '';
        data.item_name = item.title;
        data.item_variant = item.variantTitle || '';
        data.price = Number.isFinite(item.price) ? item.price / 100 : 0;
      }
      window.Shopify?.analytics?.publish?.(`oakenark:wishlist_${action}`, data);
    } catch { }
  }
  async function request(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal, credentials: 'same-origin'});
      const data = await response.json();
      if (!response.ok) throw new Error('request_failed');
      return data;
    } finally { clearTimeout(timer); }
  }
  function getProduct(handle, fresh = false) {
    const cached = products.get(handle);
    if (!fresh && cached && Date.now() - cached.at < 60000) return cached.promise;
    const promise = request(`${root}products/${encodeURIComponent(handle)}.js`);
    products.set(handle, {promise, at: Date.now()});
    promise.catch(() => products.delete(handle));
    return promise;
  }
  function productUrl(item) {
    return `${root}products/${encodeURIComponent(item.handle)}${item.variantId ? `?variant=${encodeURIComponent(item.variantId)}` : ''}`;
  }
  function safeImage(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || (url.hostname !== location.hostname && url.hostname !== 'cdn.shopify.com')) return '';
      url.searchParams.set('width', '280');
      return url.href;
    } catch { return ''; }
  }
  function snapshot(product, variantId, requiresReview = false) {
    const variant = variantId ? product.variants.find(v => String(v.id) === String(variantId)) : null;
    return {
      productId: String(product.id), handle: product.handle, variantId: variantId ? String(variantId) : null,
      title: product.title, variantTitle: variant && variant.title !== 'Default Title' ? variant.title : '',
      image: safeImage(variant?.featured_image?.src || product.featured_image || product.images?.[0] || ''),
      price: variant ? variant.price : product.price_min, currency: config.currency,
      requiresReview: Boolean(requiresReview || product.requires_selling_plan), savedAt: Date.now()
    };
  }
  function selection(button) {
    let variantId = button.dataset.variantId || null;
    if (button.dataset.source === 'product') {
      const form = button.form || button.closest('form');
      const input = form?.querySelector('[name="id"]');
      variantId = input && validId(input.value) ? input.value : variantId;
    }
    return {handle: button.dataset.handle, variantId};
  }
  function sync() {
    const saved = read();
    const savedByKey = new Map();
    saved.forEach(item => {
      const itemKey = key(item);
      if (!savedByKey.has(itemKey)) savedByKey.set(itemKey, item);
    });
    document.querySelectorAll('[data-oa-save]').forEach(button => {
      const originalLabel = button.getAttribute('aria-label');
      if (!button.dataset.originalLabel && button.dataset.originalLabel !== String(originalLabel)) button.dataset.originalLabel = originalLabel;
      const selected = selection(button);
      const item = savedByKey.get(key(selected));
      const active = Boolean(item);
      if (button.hidden) button.hidden = false;
      if (button.getAttribute('aria-pressed') !== String(active)) button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-oa-save-label]');
      const labelText = active ? t.saved : button.dataset.source === 'product' ? (t.saveLater || t.save) : t.save;
      if (label.textContent !== labelText) label.textContent = labelText;
      const ariaLabel = item ? t.removeProduct.replace('[product]', item.title) : button.dataset.originalLabel || button.getAttribute('aria-label');
      if (button.getAttribute('aria-label') !== ariaLabel) button.setAttribute('aria-label', ariaLabel);
      const title = String(button.getAttribute('aria-label'));
      if (button.title !== title) button.title = title;
    });
    document.querySelectorAll('[data-oa-open]').forEach(button => { if (button.hidden) button.hidden = false; });
    const count = saved.length ? String(saved.length) : '';
    document.querySelectorAll('[data-oa-count]').forEach(node => { if (node.textContent !== count) node.textContent = count; });
  }
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(() => { syncQueued = false; sync(); });
  }
  function money(price) {
    return new Intl.NumberFormat(config.locale || 'en', {style: 'currency', currency: config.currency || 'USD'}).format(price / 100);
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function render() {
    const saved = read();
    list.replaceChildren();
    if (!saved.length) {
      const empty = element('div', 'oa-wishlist__empty');
      empty.append(element('h3', '', t.empty), element('p', '', t.emptyHint));
      const browse = element('a', 'btn', t.browse); browse.href = config.browseUrl; empty.append(browse); list.append(empty); return;
    }
    saved.forEach(item => {
      const state = refreshed.get(key(item));
      const shown = state?.item || item;
      const row = element('article', 'oa-wishlist__item'); row.dataset.key = key(item);
      const imageLink = element('a', 'oa-wishlist__image'); imageLink.href = productUrl(item); imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden', 'true');
      const imageUrl = safeImage(shown.image);
      if (imageUrl) {
        const image = element('img'); image.src = imageUrl; image.alt = ''; image.width = 116; image.height = 116; image.loading = 'lazy'; imageLink.append(image);
      }
      const content = element('div');
      const title = element('a', 'oa-wishlist__name', shown.title); title.href = productUrl(item); title.dataset.oaItemLink = key(item); content.append(title);
      if (shown.variantTitle) content.append(element('p', 'oa-wishlist__variant', shown.variantTitle));
      if (shown.currency === config.currency && Number.isFinite(shown.price)) content.append(element('p', 'oa-wishlist__price', (item.variantId ? '' : t.from + ' ') + money(shown.price)));
      let message = state ? (state.error ? t.checkDetails : state.missing ? t.unavailable : !state.available ? t.soldOut : '') : t.checking;
      if (message) content.append(element('p', 'oa-wishlist__availability', message));
      const actions = element('div', 'oa-wishlist__actions');
      const needsDetails = !item.variantId || shown.requiresReview || state?.error || state?.missing;
      if (needsDetails) {
        const details = element('a', 'btn', !item.variantId ? t.choose : shown.requiresReview ? t.review : t.details);
        details.href = productUrl(item); details.dataset.oaItemLink = key(item); actions.append(details);
      } else {
        const add = element('button', 'btn', t.add); add.type = 'button'; add.dataset.oaAdd = key(item); add.disabled = !state?.available; actions.append(add);
      }
      const remove = element('button', 'oa-wishlist__remove', t.remove); remove.type = 'button'; remove.dataset.oaRemove = key(item); remove.setAttribute('aria-label', t.removeProduct.replace('[product]', shown.title)); actions.append(remove);
      content.append(actions); row.append(imageLink, content); list.append(row);
    });
  }
  async function hydrate() {
    const version = ++refreshVersion;
    const saved = [...read()];
    const handles = [...new Set(saved.map(x => x.handle))];
    let next = 0;
    await Promise.all(Array.from({length: Math.min(3, handles.length)}, async () => {
      while (next < handles.length) {
        const handle = handles[next++];
        try {
          const product = await getProduct(handle, true);
          if (version !== refreshVersion) return;
          saved.filter(x => x.handle === handle).forEach(item => {
            const variant = item.variantId && product.variants.find(v => String(v.id) === item.variantId);
            refreshed.set(key(item), {item: snapshot(product, item.variantId, item.requiresReview), missing: Boolean(item.variantId && !variant), available: item.variantId ? Boolean(variant?.available) : product.available});
          });
        } catch {
          if (version !== refreshVersion) return;
          saved.filter(x => x.handle === handle).forEach(item => refreshed.set(key(item), {error: true}));
        }
      }
    }));
    if (version !== refreshVersion || !dialog.open) return;
    const focusKey = document.activeElement?.closest('[data-key]')?.dataset.key;
    const focusAction = document.activeElement?.hasAttribute('data-oa-remove') ? 'remove' : document.activeElement?.hasAttribute('data-oa-add') ? 'add' : null;
    render();
    if (focusKey && focusAction) Array.from(list.querySelectorAll(`[data-oa-${focusAction}]`)).find(x => x.dataset[focusAction === 'remove' ? 'oaRemove' : 'oaAdd'] === focusKey)?.focus();
  }
  function remove(itemKey, source) {
    const saved = read(); const item = saved.find(x => key(x) === itemKey); if (!item) return;
    const persisted = write(saved.filter(x => key(x) !== itemKey));
    sync(); if (dialog.open) { render(); (list.querySelector('button,a') || dialog.querySelector('[data-oa-close]')).focus(); }
    notify(persisted ? t.removedNotice : t.storageError); track('removed', item, source);
  }
  async function toggle(button) {
    if (button.disabled) return;
    const selected = selection(button); const itemKey = key(selected);
    if (read().some(x => key(x) === itemKey)) { remove(itemKey, button.dataset.source); return; }
    if (memory.length >= 100) { notify(t.limit); return; }
    button.disabled = true; button.querySelector('[data-oa-save-label]').textContent = t.saving;
    try {
      const product = await getProduct(selected.handle);
      if (selected.variantId && !product.variants.some(v => String(v.id) === selected.variantId)) throw new Error('missing_variant');
      const form = button.form || button.closest('form');
      const review = button.dataset.review === 'true' || Array.from(form?.elements || []).some(field => field.name?.startsWith('properties[') || field.name === 'selling_plan');
      const item = snapshot(product, selected.variantId, review);
      const current = read();
      if (!current.some(x => key(x) === itemKey)) {
        if (current.length >= 100) { notify(t.limit); return; }
        const persisted = write([item, ...current]);
        notify(persisted ? t.savedNotice : t.storageError); track('added', item, button.dataset.source);
      }
    } catch { notify(t.networkError); }
    finally { button.disabled = false; sync(); }
  }
  async function addToCart(button) {
    const item = read().find(x => key(x) === button.dataset.oaAdd);
    if (!item || button.disabled) return;
    button.disabled = true; button.textContent = t.adding;
    try {
      const product = await getProduct(item.handle, true);
      const variant = product.variants.find(v => String(v.id) === item.variantId);
      if (!variant?.available || product.requires_selling_plan || item.requiresReview) throw new Error('unavailable');
      const updated = snapshot(product, item.variantId, false);
      await request(`${root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(item.variantId), quantity: 1}]})});
      button.textContent = t.added; notify(t.added); track('add_to_cart', updated);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.querySelectorAll('.cart-link__bubble').forEach(node => node.classList.add('cart-link__bubble--visible'));
      setTimeout(() => { if (button.isConnected) { button.disabled = false; button.textContent = t.add; } }, 1800);
    } catch {
      notify(t.cartError); button.disabled = false; button.textContent = t.add;
    }
  }
  function open(button) {
    opener = button; status.textContent = ''; refreshed.clear(); render(); dialog.showModal();
    dialog.querySelector('[data-oa-close]').focus(); track('viewed'); hydrate();
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a'); if (!target) return;
    if (target.matches('[data-oa-save]')) { event.preventDefault(); event.stopPropagation(); toggle(target); }
    else if (target.matches('[data-oa-open]')) { event.preventDefault(); open(target); }
    else if (target.matches('[data-oa-close]')) dialog.close();
    else if (target.matches('[data-oa-remove]')) remove(target.dataset.oaRemove, 'saved_list');
    else if (target.matches('[data-oa-add]')) addToCart(target);
    else if (target.matches('[data-oa-item-link]')) track('product_opened', read().find(x => key(x) === target.dataset.oaItemLink));
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { refreshVersion++; opener?.focus(); });
  document.addEventListener('change', event => { if (event.target.closest('[data-section-type="product"]')) scheduleSync(); });
  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('page:loaded', scheduleSync);
  window.addEventListener('pageshow', event => { if (event.persisted) scheduleSync(); });
  window.addEventListener('storage', event => { if (event.key === storageKey || event.key === null) { scheduleSync(); if (dialog.open) { refreshed.clear(); render(); hydrate(); } } });
  const observer = new MutationObserver(mutations => {
    if (!mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && (n.matches?.('[data-oa-save],[data-oa-open]') || n.querySelector?.('[data-oa-save],[data-oa-open]'))))) return;
    scheduleSync();
  });
  observer.observe(document.getElementById('PageContainer') || document.body, {childList: true, subtree: true});
  sync();
})();
